// Pill do usuário no header + menu (mockup Aeros): avatar com dot de status,
// nome e perfil; menu com cabeçalho, Online/Ausente, Meu perfil,
// Preferências, Ajuda e tutoriais, Sair.
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { makeStyles, alpha } from "@material-ui/core/styles";
import Popover from "@material-ui/core/Popover";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import PersonOutlineIcon from "@material-ui/icons/PersonOutline";
import TuneIcon from "@material-ui/icons/Tune";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import { AEROS, stateText } from "../../styles/aerosTokens";
import useHeaderStyles from "./headerStyles";
import { initialsOf } from "../../pages/Contacts/contactRules";
import { i18n } from "../../translate/i18n";

const roleLabel = (p) => (p === "admin" ? "Admin" : p === "supervisor" ? "Supervisor" : i18n.t("aeros.reports.filters.user"));

const useStyles = makeStyles((theme) => {
  const isLight = theme.palette.type === "light";
  return {
    pill: { display: "flex", alignItems: "center", gap: 9, padding: "4px 8px 4px 4px", borderRadius: 10, background: "none", border: "none", cursor: "pointer", font: "inherit", color: theme.palette.text.primary, "&:hover": { backgroundColor: isLight ? theme.palette.action.hover : "rgba(255,255,255,0.06)" } },
    avWrap: { position: "relative" },
    av: { width: 32, height: 32, borderRadius: "50%", background: "linear-gradient(135deg,#A044FF,#22D3EE)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 12, fontWeight: 800, color: "#07080D", overflow: "hidden", "& img": { width: "100%", height: "100%", objectFit: "cover" } },
    st: { position: "absolute", right: -1, bottom: -1, width: 10, height: 10, borderRadius: "50%", border: `2px solid ${theme.palette.aeros.surface}` },
    // No celular o pill vira so o avatar: nome/cargo e a seta consomem ~90px
    // que a barra de 375px nao tem. O nome completo continua no popover.
    txt: { [theme.breakpoints.down("sm")]: { display: "none" } },
    name: { fontSize: 12.5, fontWeight: 600, lineHeight: 1.2, textAlign: "left" },
    role: { fontSize: 10.5, color: theme.palette.text.secondary, lineHeight: 1.2, textAlign: "left" },
    chev: { fontSize: 16, color: theme.palette.aeros.textTertiary, [theme.breakpoints.down("sm")]: { display: "none" } },
    mhead: { display: "flex", alignItems: "center", gap: 10, padding: "8px 10px 12px", borderBottom: `1px solid ${isLight ? theme.palette.divider : "rgba(255,255,255,0.07)"}`, marginBottom: 6 },
    mav: { width: 38, height: 38, borderRadius: "50%", background: "linear-gradient(135deg,#A044FF,#22D3EE)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 13, fontWeight: 800, color: "#07080D", overflow: "hidden", flex: "none", "& img": { width: "100%", height: "100%", objectFit: "cover" } },
    mname: { fontSize: 13, fontWeight: 700, color: theme.palette.text.primary },
    memail: { fontSize: 11, color: theme.palette.text.secondary, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" },
    presence: { display: "flex", gap: 6, padding: "0 4px 8px" },
    pbtn: { flex: 1, display: "flex", alignItems: "center", justifyContent: "center", gap: 6, fontSize: 11.5, fontWeight: 600, borderRadius: 8, padding: "6px 10px", background: "none", cursor: "pointer", font: "inherit", color: theme.palette.text.secondary, border: `1px solid ${isLight ? theme.palette.aeros.borderStrong : "rgba(255,255,255,0.1)"}`, "& i": { width: 6, height: 6, borderRadius: "50%" } },
    pOn: { color: stateText(theme, AEROS.success, "success"), backgroundColor: alpha(AEROS.success, 0.1), borderColor: alpha(AEROS.success, 0.3) },
    pAway: { color: stateText(theme, AEROS.warning, "warning"), backgroundColor: alpha(AEROS.warning, 0.1), borderColor: alpha(AEROS.warning, 0.3) },
    hint: { fontSize: 10.5, color: theme.palette.aeros.textTertiary, fontWeight: 500 },
    danger: { color: `${stateText(theme, AEROS.error, "error")} !important` },
  };
});

export default function UserMenu({ user, profileUrl, presence = "online", onPresence, onProfile, onPreferences, onLogout }) {
  const h = useHeaderStyles();
  const classes = useStyles();
  const history = useHistory();
  const [anchor, setAnchor] = useState(null);
  const close = () => setAnchor(null);
  const dotColor = presence === "away" ? AEROS.warning : AEROS.success;
  const av = (cls) => <div className={cls}>{profileUrl ? <img src={profileUrl} alt="" /> : initialsOf(user?.name || "?")}</div>;
  const Item = ({ icon: Icon, label, hint, onClick, danger }) => (
    <button type="button" className={`${h.row} ${danger ? classes.danger : ""}`} onClick={() => { close(); onClick(); }} style={{ fontWeight: 500 }}>
      <Icon style={danger ? undefined : { color: undefined }} /><span style={{ flex: 1 }}>{label}</span>{hint && <span className={classes.hint}>{hint}</span>}
    </button>
  );

  return (
    <>
      <button type="button" className={classes.pill} onClick={(e) => setAnchor(e.currentTarget)} aria-label={i18n.t("aeros.header.userMenu")} aria-haspopup="true">
        <div className={classes.avWrap}>{av(classes.av)}<div className={classes.st} style={{ backgroundColor: dotColor }} /></div>
        <div className={classes.txt}>
          <div className={classes.name}>{(user?.name || "").split(" ")[0]}</div>
          <div className={classes.role}>{roleLabel(user?.profile)}</div>
        </div>
        <ExpandMoreIcon className={classes.chev} />
      </button>
      <Popover open={Boolean(anchor)} anchorEl={anchor} onClose={close} classes={{ paper: h.paper }} anchorOrigin={{ vertical: "bottom", horizontal: "right" }} transformOrigin={{ vertical: "top", horizontal: "right" }}>
        <div className={h.pad} style={{ width: 280 }}>
          <div className={classes.mhead}>
            {av(classes.mav)}
            <div style={{ flex: 1, minWidth: 0 }}>
              <div className={classes.mname}>{user?.name}</div>
              <div className={classes.memail}>{user?.email}</div>
            </div>
          </div>
          <div className={classes.presence}>
            <button type="button" className={`${classes.pbtn} ${presence !== "away" ? classes.pOn : ""}`} onClick={() => onPresence("online")}><i style={{ background: AEROS.success }} />{i18n.t("aeros.header.online")}</button>
            <button type="button" className={`${classes.pbtn} ${presence === "away" ? classes.pAway : ""}`} onClick={() => onPresence("away")}><i style={{ background: AEROS.warning }} />{i18n.t("aeros.header.away")}</button>
          </div>
          <Item icon={PersonOutlineIcon} label={i18n.t("aeros.header.myProfile")} onClick={onProfile} />
          <Item icon={TuneIcon} label={i18n.t("aeros.header.preferences")} hint={i18n.t("aeros.header.preferencesHint")} onClick={onPreferences} />
          <Item icon={HelpOutlineIcon} label={i18n.t("aeros.header.helpTutorials")} onClick={() => history.push("/helps")} />
          <div className={h.divider} />
          <Item icon={ExitToAppIcon} label={i18n.t("aeros.header.logout")} onClick={onLogout} danger />
        </div>
      </Popover>
    </>
  );
}
